import useSWR from 'swr'
import { coursesWithSubcatsImportPromiseDeprecated } from 'experiments/pen-2866_v1_alternative_categories/subcatImportPromise'
import type { CoursesFixture } from 'experiments/pen-2866_v1_alternative_categories/types'

export const useCourseMappingDeprecated = (
  courses: Array<{ slug: string }>,
) => {
  // `hash` identifies the `courses` param. By including `hash` in the SWR key
  // we inform SWR that the param has changed, so SWR will refresh the data
  const hash = simpleHash(courses.map((c) => c.slug).join('/'))
  const key = `course-mapping-pen2866-catpage-${hash}`

  const {
    data: courseMapping,
    isValidating,
    ...rest
  } = useSWR(
    key,
    () =>
      coursesWithSubcatsImportPromiseDeprecated()
        .then((m) => m.default)
        .then((allCourses) => {
          const courseSlugs = new Set(courses.map((c) => c.slug))
          const entries = Object.entries(allCourses).filter(([_, c]) =>
            courseSlugs.has(c.slug),
          )
          return Object.fromEntries(entries) as CoursesFixture
        }),
    {
      revalidateOnFocus: false,
      revalidateIfStale: false,
      revalidateOnReconnect: false,
    },
  )

  return { courseMapping, ...rest }
}

// thanks https://gist.github.com/jlevy/c246006675becc446360a798e2b2d781
const simpleHash = (str: string) => {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i)
    // eslint-disable-next-line no-bitwise
    hash = (hash << 5) - hash + char
  }
  // Convert to 32bit unsigned integer in base 36 and pad with "0" to ensure length is 7.
  // eslint-disable-next-line no-bitwise
  return (hash >>> 0).toString(36).padStart(7, '0')
}
